
<div mat-dialog-title>Import Accounts to Portfolio Assignments@if (!showProgressBar) {
  <button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button>
}</div>
<mat-dialog-content>
  @if (!showProgressBar) {
    <div>
      @if (hasFile && !isValidFile) {
        <mat-card class="error block">
          <mat-card-title class="error">{{invalidFileErrorHeader}}</mat-card-title>
          <mat-card-subtitle
          style="font-family: Arial;font-size: 13px;color: #000000;">{{invalidFileErrorMessage}}</mat-card-subtitle>
        </mat-card>
      }
      @if (errorMessage) {
        <mat-card class="error block">
          <mat-card-title class="error">An error occurred.</mat-card-title>
          <mat-card-subtitle style="font-family: Arial;font-size: 13px;color: #000000;">{{errorMessage}}</mat-card-subtitle>
        </mat-card>
      }
      <div>
        <table class="import" width="100%">
          <tr>
            <th align="left" style="vertical-align: top;"><label>File name</label></th>
            <td>
              <div class="bottomPaddingElementDialog">
                <irb-file-selector (change)="onFileChange($event)"></irb-file-selector>
                <div>File type must be .csv</div>
              </div>
            </td>
          </tr>
          <tr>
            <th align="left" style="vertical-align: top;"><label>Instructions</label></th>
            <td>
              <div class="block">Your selected file must be in .csv format and follow iRebal's format:<br/>Account No.,
                Portfolio Name
              </div>
            </td>
          </tr>
          <tr>
            <th align="left" style="vertical-align: top;"><label>Template</label></th>
            <td>
              <div>Use our .csv template to prepare your file.<br/>
                <a href="/assets/template/accounts_portfolio.csv">Download template: accounts_portfolio.csv</a></div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    }
    @if (showProgressBar) {
      <div class="dialog-body flex progress-bar">
        <irb-progress-bar [progressValue]="progressBarValue"></irb-progress-bar>
      </div>
    }
  </mat-dialog-content>
  @if (!showProgressBar) {
    <mat-dialog-actions>
      <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
      <button id="continueButton" (click)="submitFile()" [disabled]="!(hasFile && isValidFile)" class="btn-medium-primary">
        Continue
      </button>
    </mat-dialog-actions>
  }

